import { Parametric } from "../../cliente/parametric.model";
import { Departamento } from "../../cliente/departamento.model";

export class Direccion {

  direccion: string;
  numero: string;
  piso: string;
  departamento: string;
  codigoPostal: string;
  ciudad: string;
  provincia: Parametric;
  pais: Parametric;
  departamentoProvincia: Departamento;

}



// WEBPACK FOOTER //
// ./src/app/security/user/direccion.model.ts